import { HtmlStringParser, IHtmlStringParser } from "@pjs/security";
import { compactMultiLineConfig } from "./full-configs/CompactMultiLineConfig.const";

export const compactMultiLineParser: IHtmlStringParser = new HtmlStringParser(compactMultiLineConfig, null);
